import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlannerClassicPlanRoute: InvariantJiraRoute = {
	name: 'software-planner-classic-plan',
	path: '/jira/software/c/projects/:projectKey/planner/:planId',
	exact: true,
};
